import axiosInstance from '../utils/axios';

const API_BASE = '/api/v2';

const mktAccountsService = {

    // includePending: contas que ainda nao terminaram de conectar (hoje so
    // WhatsApp, parado em awaiting_phone/awaiting_pin). So a tela de Contas
    // Sociais pede — e' de la que se conclui a conexao. O seletor de vinculo
    // do canal NAO pede: conta incompleta nao pode ser vinculada.
    listar: async (clienteId, { provider, onlyReal = true, includePending = false } = {}) => {
        const response = await axiosInstance.get(`${API_BASE}/${clienteId}/mkt/accounts`, {
            params: {
                provider,
                only_real: onlyReal ? 'true' : undefined,
                include_pending: includePending ? 'true' : undefined
            }
        });
        return response.data;
    },

    // Mercado Livre: quem monta a URL de autorizacao e o BACKEND, nao o front
    // (ao contrario do Meta, ver metaOAuth.js). O state e assinado e o
    // code_verifier do PKCE nao pode passar pelo navegador — por isso aqui so se
    // pede a URL pronta.
    iniciarOAuthMercadoLivre: async (clienteId) => {
        const response = await axiosInstance.get(`${API_BASE}/${clienteId}/mkt/auth/mercadolivre/start`);
        return response.data;
    },

    // Embedded Signup do WhatsApp sem canal — o destino e' a conta social.
    onboardWhatsapp: async (clienteId, data) => {
        const response = await axiosInstance.post(`${API_BASE}/${clienteId}/mkt/accounts/whatsapp/onboard`, data);
        return response.data;
    },

    registrarNumeroWhatsapp: async (accountId, pin) => {
        const response = await axiosInstance.post(`${API_BASE}/mkt/accounts/${accountId}/whatsapp/register`, { pin });
        return response.data;
    },

    buscar: async (id) => {
        const response = await axiosInstance.get(`${API_BASE}/mkt/accounts/${id}`);
        return response.data;
    },

    // clienteId e obrigatorio: a rota e (clienteId, id), nunca so o id —
    // esse era o bug de aridade do MktAccounts.js antigo.
    deletar: async (clienteId, id) => {
        const response = await axiosInstance.delete(`${API_BASE}/${clienteId}/mkt/accounts/${id}`);
        return response.data;
    },

    sincronizar: async (id) => {
        const response = await axiosInstance.post(`${API_BASE}/mkt/accounts/${id}/sync`);
        return response.data;
    },

    getBusinessProfile: async (id) => {
        const response = await axiosInstance.get(`${API_BASE}/mkt/accounts/${id}/whatsapp/business-profile`);
        return response.data;
    },

    updateBusinessProfile: async (id, data) => {
        const response = await axiosInstance.post(`${API_BASE}/mkt/accounts/${id}/whatsapp/business-profile`, data);
        return response.data;
    },

    updateBusinessProfilePicture: async (id, file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await axiosInstance.post(
            `${API_BASE}/mkt/accounts/${id}/whatsapp/business-profile/picture`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        return response.data;
    },

    getFacebookPageProfile: async (id) => {
        const response = await axiosInstance.get(`${API_BASE}/mkt/accounts/${id}/facebook/page-profile`);
        return response.data;
    },

    updateFacebookPageProfile: async (id, data) => {
        const response = await axiosInstance.post(`${API_BASE}/mkt/accounts/${id}/facebook/page-profile`, data);
        return response.data;
    },

    updateFacebookPagePicture: async (id, file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await axiosInstance.post(
            `${API_BASE}/mkt/accounts/${id}/facebook/page-profile/picture`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        return response.data;
    },

    getInstagramProfile: async (id) => {
        const response = await axiosInstance.get(`${API_BASE}/mkt/accounts/${id}/instagram/profile`);
        return response.data;
    },

    // Metricas do painel de perfil. Separadas dos endpoints de perfil acima:
    // aquelas seguram o loading da tela, estas preenchem depois.
    // params: { days, timeframe, includeAudience, refresh }
    getInstagramMetrics: async (id, { days = 30, timeframe, includeAudience, refresh } = {}) => {
        const response = await axiosInstance.get(`${API_BASE}/mkt/accounts/${id}/instagram/metrics`, {
            params: {
                days,
                timeframe,
                include: includeAudience ? 'audience' : undefined,
                refresh: refresh ? 'true' : undefined,
            },
        });
        return response.data;
    },

    getFacebookPageMetrics: async (id, { days = 30, includeAudience, refresh } = {}) => {
        const response = await axiosInstance.get(`${API_BASE}/mkt/accounts/${id}/facebook/metrics`, {
            params: {
                days,
                include: includeAudience ? 'audience' : undefined,
                refresh: refresh ? 'true' : undefined,
            },
        });
        return response.data;
    },

    exchangeMetaCode: async (clienteId, data) => {
        const response = await axiosInstance.post(`${API_BASE}/${clienteId}/mkt/auth/meta/exchange`, data);
        return response.data;
    },

    connectMetaAccount: async (clienteId, data) => {
        const response = await axiosInstance.post(`${API_BASE}/${clienteId}/mkt/auth/meta/connect`, data);
        return response.data;
    },

    // Sessao OAuth pendente (apos login Facebook) — usuario escolhe antes de criar contas
    getOAuthPending: async (clienteId, sessionId) => {
        const response = await axiosInstance.get(`${API_BASE}/${clienteId}/mkt/auth/meta/pending/${sessionId}`);
        return response.data;
    },

    confirmOAuthPending: async (clienteId, sessionId, data) => {
        const response = await axiosInstance.post(
            `${API_BASE}/${clienteId}/mkt/auth/meta/pending/${sessionId}/confirm`,
            data
        );
        return response.data;
    },

    discardOAuthPending: async (clienteId, sessionId) => {
        const response = await axiosInstance.delete(`${API_BASE}/${clienteId}/mkt/auth/meta/pending/${sessionId}`);
        return response.data;
    },

};

export default mktAccountsService;
